import { getTracerModules } from '@apptracer/sdk/lite';
import { Autologin } from '@vk-ecosystem/sdk';

import { packageName, widgetUrl, widgetVkIdState } from '../../../config';
import { getVkIdInternalApi } from '../../api/getVkIdInternalApi';
import { VKID_AUTOLOGIN_KEY } from '../../constants/localStorage';
import { getVkIdResponse } from '../getVkIdResponse';
import { storageManager } from '../storageManager';
import { tokenManager } from '../tokenManager';

const exchangeVkIdToken = async (widgetUuid: string, vkIdToken: string, vkIdUuid: string) => {
  const data = await getVkIdInternalApi(widgetUuid, vkIdToken, vkIdUuid);

  if (data) {
    tokenManager.setAuthData(data);
  }
};

export const getAutologinRedirect = (widgetUuid: string) => {
  const tracerError = getTracerModules(packageName).error;

  // Получение токена для внутренних сервисов
  const handleGetToken = async () => {
    try {
      storageManager?.removeItem(VKID_AUTOLOGIN_KEY);
    } catch (_) {
      tracerError?.error('Не удалось удалить флаг из хранилища', {
        keys: {
          flag: VKID_AUTOLOGIN_KEY,
        },
      });
    }
    const { payload: vkIdPayload } = getVkIdResponse();

    if (vkIdPayload && widgetUuid) {
      await exchangeVkIdToken(widgetUuid, vkIdPayload.token, vkIdPayload.uuid);
    }
  };

  // Обработка результатов инициализации VK ID на странице
  const handleInitVkId = async () => {
    const { payload: vkIdPayload } = getVkIdResponse();

    if (vkIdPayload && widgetUuid) {
      // Токена нет, зашли первый раз
      if (!tokenManager.getToken()) {
        await exchangeVkIdToken(widgetUuid, vkIdPayload.token, vkIdPayload.uuid);
      } else if (tokenManager.getToken() && tokenManager.getIsTokenExpired()) {
        // есть токен, зашли второй раз, но он просрочен
        await handleGetToken();
      }
    } else if (!vkIdPayload && tokenManager.getToken() && tokenManager.getIsTokenExpired()) {
      await handleGetToken();
    }
  };

  Autologin.autologinRedirect({
    autologin_delay: 0.5,
    url: widgetUrl,
    state: widgetVkIdState,
    callback: () => {
      void handleInitVkId();
    },
  });
};
